import { useQuery } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useReviewer(email: string | undefined) {
  return useQuery({
    ...apiClient.getReviewerBySubReviewersSubGetOptions({
      path: {
        sub: email ?? '',
      },
    }),
    enabled: Boolean(email),
    staleTime: 1000 * 60 * 60,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    retry: false,
  })
}
